module.exports = __webpack_public_path__ + "static/media/8.18eccdfe.svg";